// extracted by mini-css-extract-plugin
module.exports = {"overlay":"DragDropOverlay_overlay__E3hTK","fadeIn":"DragDropOverlay_fadeIn__znlNo","content":"DragDropOverlay_content__A0vTO"};